module.exports = __webpack_public_path__ + "img/81.4b23e1a4.png";